import Video from './Video'
import Footer from '../utils/Footer';
import Home from './Home';
import Header from '../utils/Header'
export default function CompleteHome() {
    return (
      <>
      
        <Header home={true}/>
        <Video/>
        <Home />
        <Footer />
      </>
    );
  }
  